export const getLastDot = (name: string) => name.lastIndexOf('.');
